function setCurrentUser({ input, state, output }) {
  state.set('client.currentUser', input.result.user)
  output.doesExist()
}

setCurrentUser.outputs = ['isDeleted', 'doesExist']
export default setCurrentUser



// WEBPACK FOOTER //
// ./src/modules/user/actions/setCurrentUser.js